import { useState } from "react";
import { useAuth } from "../lib/auth";
import { Navigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Trophy } from "lucide-react";

export default function LoginPage() {
  const { user, login, register, error } = useAuth();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "/app";
  const [mode, setMode] = useState(searchParams.get("mode") === "register" ? "register" : "login");
  const [email, setEmail] = useState("admin@calcioclub.it");
  const [password, setPassword] = useState("admin123");
  const [name, setName] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user !== false) return <Navigate to={redirect} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    if (mode === "login") await login(email, password);
    else await register(email, password, name);
    setSubmitting(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      {/* Left visual panel */}
      <div
        className="hidden lg:flex relative overflow-hidden items-end p-12"
        style={{
          backgroundImage:
            "linear-gradient(135deg, rgba(14,165,233,0.85), rgba(34,197,94,0.7)), url('https://static.prod-images.emergentagent.com/jobs/45f8a863-71a9-4e1f-aa00-24928063dbe8/images/6fb46adc7613a40732cfa540c378e8911480eee888ef3d3d99c41258780b7a22.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="text-white max-w-lg">
          <div className="label-eyebrow text-white/80 mb-4">CALCIO CLUB MANAGER</div>
          <h1 className="font-heading text-5xl font-bold leading-[1.05] mb-4">
            Lo spogliatoio digitale del tuo settore giovanile.
          </h1>
          <p className="text-white/85 text-lg max-w-md">
            Anagrafica, convocazioni, presenze, allenamenti e lavagna tattica — tutto in un unico
            posto.
          </p>
        </div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-10">
            <div className="h-11 w-11 rounded-2xl bg-sky-500 flex items-center justify-center">
              <Trophy className="text-white" size={22} />
            </div>
            <div>
              <div className="font-heading font-bold text-xl leading-none">Calcio Club</div>
              <div className="text-xs text-slate-500">Manager · Multi-squadra</div>
            </div>
          </div>

          <Tabs value={mode} onValueChange={setMode} className="w-full">
            <TabsList className="grid grid-cols-2 mb-6">
              <TabsTrigger value="login" data-testid="tab-login">
                Accedi
              </TabsTrigger>
              <TabsTrigger value="register" data-testid="tab-register">
                Registrati
              </TabsTrigger>
            </TabsList>
            <TabsContent value="login">
              <Card className="p-6 border-slate-200 shadow-sm">
                <form onSubmit={submit} className="space-y-4">
                  <div>
                    <Label htmlFor="email">Email</Label>
                    <Input
                      id="email"
                      type="email"
                      value={email}
                      data-testid="login-email"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <Label htmlFor="password">Password</Label>
                    <Input
                      id="password"
                      type="password"
                      value={password}
                      data-testid="login-password"
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  {error && (
                    <p className="text-sm text-red-600" data-testid="login-error">
                      {error}
                    </p>
                  )}
                  <Button
                    type="submit"
                    className="w-full rounded-full bg-sky-500 hover:bg-sky-600"
                    disabled={submitting}
                    data-testid="login-submit"
                  >
                    {submitting ? "Accesso..." : "Entra in spogliatoio"}
                  </Button>
                </form>
              </Card>
            </TabsContent>
            <TabsContent value="register">
              <Card className="p-6 border-slate-200 shadow-sm">
                <form onSubmit={submit} className="space-y-4">
                  <div>
                    <Label htmlFor="rname">Nome Mister</Label>
                    <Input
                      id="rname"
                      value={name}
                      data-testid="register-name"
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <Label htmlFor="remail">Email</Label>
                    <Input
                      id="remail"
                      type="email"
                      value={email}
                      data-testid="register-email"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div>
                    <Label htmlFor="rpassword">Password</Label>
                    <Input
                      id="rpassword"
                      type="password"
                      value={password}
                      data-testid="register-password"
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  {error && <p className="text-sm text-red-600">{error}</p>}
                  <Button
                    type="submit"
                    className="w-full rounded-full bg-emerald-500 hover:bg-emerald-600"
                    disabled={submitting}
                    data-testid="register-submit"
                  >
                    {submitting ? "Creazione..." : "Crea account"}
                  </Button>
                </form>
              </Card>
            </TabsContent>
          </Tabs>

          <p className="text-xs text-slate-500 mt-6 text-center">
            Demo: admin@calcioclub.it / admin123
          </p>
        </div>
      </div>
    </div>
  );
}
